import _ from 'lodash'
import Vue from 'vue'

Vue.directive('emoji', {
    inserted (el) {
        el.innerHTML = window.twemoji.parse(_.replace(el.innerHTML, /\B\((y|Y)\)\B/g, '👍'))
    }
})
